import { render, staticRenderFns } from "./FormComponentsProactiveHelp.vue?vue&type=template&id=2b3c05de&scoped=true"
import script from "./FormComponentsProactiveHelp.vue?vue&type=script&lang=js"
export * from "./FormComponentsProactiveHelp.vue?vue&type=script&lang=js"
import style0 from "./FormComponentsProactiveHelp.vue?vue&type=style&index=0&id=2b3c05de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c05de",
  null
  
)

export default component.exports